import React from 'react';
export default function ContactForm() {
  return (
    <>
      <header>
        <h2>Contact</h2>
      </header>
      <div className="content">
        <form>
          <div className="fields">
            <div className="field half" style={{ color: '#000000' }}>
              <input type="text" name="name" id="name" placeholder="Name" />
            </div>
            <div className="field half" style={{ color: '#000000' }}>
              <input type="email" name="email" id="email" placeholder="Email" />
            </div>
            <div className="field" style={{ color: '#000000' }}>
              <textarea
                name="message"
                id="message"
                placeholder="Message"
                rows="7"
              />
            </div>
          </div>
          <ul className="actions">
            <li>
              <input
                disabled
                type="submit"
                value="Send Message"
                className="button primary"
              />
            </li>
          </ul>
        </form>
      </div>
    </>
  );
}
